import {
  Maybe,
  SentCardSendType,
  Operation,
} from '../../../__generated__/globalTypes'

import getCardsCountsString from '../GetCardCounts.graphql'

export type GetCardsCountsData = {
  sentCards: {
    sentCards: {
      date: string
      cardsSent: number
    }[]
    count: number
  }
}

export type GetCardsCountsVariables = {
  startDate: string
  endDate: string
  sendType?: Maybe<SentCardSendType>
}

export type GetCardsCounts = Operation<
  GetCardsCountsData,
  GetCardsCountsVariables
>

export const GetCardsCounts = ({
  startDate,
  endDate,
  sendType,
}: GetCardsCountsVariables): GetCardsCounts => ({
  query: getCardsCountsString,
  variables: {
    startDate,
    endDate,
    sendType,
  },
})
